module.exports = __webpack_public_path__ + "img/mianyi.703e40c5.png";